import React, { useEffect, useRef } from "react";
import {
  Animated,
  StyleProp,
  StyleSheet,
  TouchableOpacity,
  View,
  ViewStyle,
} from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { router } from "expo-router";

interface BellNotification {
  hasPendingNotifications: boolean;
  iconColor?: string;
  iconSize?: number;
  style?: StyleProp<ViewStyle> | undefined;
}

function BellNotification({
  hasPendingNotifications,
  iconColor = "#F2F2F7",
  iconSize = 24,
  style = undefined,
}: BellNotification): React.JSX.Element {
  const opacity = useRef(new Animated.Value(1)).current;

  const handleNavigateToNotifications = (): void => {
    router.push("/(main)/shared/user-notifications");
  };

  useEffect(() => {
    if (hasPendingNotifications) {
      Animated.sequence([
        Animated.timing(opacity, {
          duration: 1000,
          toValue: 0, // Longer duration for fading out
          useNativeDriver: true,
        }),
        Animated.timing(opacity, {
          duration: 1000,
          toValue: 1, // Longer duration for fading in
          useNativeDriver: true,
        }),
      ]).start();
    }
  }, [hasPendingNotifications, opacity]);

  return (
    <View style={[styles.container]}>
      <TouchableOpacity
        style={style}
        onPress={handleNavigateToNotifications}
        hitSlop={8}
      >
        <View style={styles.iconWrapper}>
          <Ionicons
            name="notifications-outline"
            size={iconSize}
            color={iconColor}
          />
          {hasPendingNotifications && (
            <Animated.View style={[styles.pendingIndicator, { opacity }]} />
          )}
        </View>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
  },
  iconWrapper: {
    position: "relative",
  },
  pendingIndicator: {
    backgroundColor: "red",
    borderRadius: 4,
    height: 8,
    position: "absolute",
    right: 3,
    top: 3,
    width: 8,
  },
});

export default BellNotification;
